var _path, _path2, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyConversation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 104,
    viewBox: "0 0 124 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3267 63.225H19.8267C19.8267 62.3966 19.1551 61.725 18.3267 61.725V63.225ZM18.3267 79.5519H16.8267C16.8267 80.1513 17.1834 80.6931 17.734 80.9299C18.2845 81.1667 18.9232 81.0531 19.3583 80.6409L18.3267 79.5519ZM35.5607 63.225V61.725C35.1769 61.725 34.8077 61.8721 34.5291 62.1361L35.5607 63.225ZM3.5 4C3.5 3.72386 3.72386 3.5 4 3.5V0.5C2.067 0.5 0.5 2.067 0.5 4H3.5ZM3.5 61.225V4H0.5V61.225H3.5ZM4 61.725C3.72386 61.725 3.5 61.5011 3.5 61.225H0.5C0.5 63.158 2.067 64.725 4 64.725V61.725ZM18.3267 61.725H4V64.725H18.3267V61.725ZM16.8267 63.225V79.5519H19.8267V63.225H16.8267ZM19.3583 80.6409L36.5923 64.3139L34.5291 62.1361L17.295 78.463L19.3583 80.6409ZM78.368 61.725H35.5607V64.725H78.368V61.725ZM78.868 61.225C78.868 61.5011 78.6441 61.725 78.368 61.725V64.725C80.301 64.725 81.868 63.158 81.868 61.225H78.868ZM78.868 4V61.225H81.868V4H78.868ZM78.368 3.5C78.6441 3.5 78.868 3.72386 78.868 4H81.868C81.868 2.067 80.301 0.5 78.368 0.5V3.5ZM4 3.5H78.368V0.5H4V3.5Z",
    fill: "#1890FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3574 63.225V83.6732C43.3574 85.6062 44.9244 87.1732 46.8574 87.1732H89.067L105.867 103.089C106.302 103.501 106.941 103.615 107.491 103.378C108.042 103.141 108.399 102.599 108.399 102V87.1732H120.409C122.342 87.1732 123.909 85.6062 123.909 83.6732V36.6523C123.909 34.7193 122.342 33.1523 120.409 33.1523H80.368V36.1523H120.409C120.685 36.1523 120.909 36.3762 120.909 36.6523V83.6732C120.909 83.9493 120.685 84.1732 120.409 84.1732H106.899C106.07 84.1732 105.399 84.8447 105.399 85.6732V98.5128L90.6964 84.5842C90.4177 84.3203 90.0485 84.1732 89.6647 84.1732H46.8574C46.5813 84.1732 46.3574 83.9493 46.3574 83.6732V63.225H43.3574Z",
    fill: "#1890FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9632,
    cy: 33.1115,
    r: 4.44448,
    fill: "#1890FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5189,
    cy: 33.1115,
    r: 4.44448,
    fill: "#1890FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.0746,
    cy: 33.1115,
    r: 4.44448,
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyConversation);
export default __webpack_public_path__ + "static/media/My-Conversation.4c8e5bca1e56b69d8492d5bf6ce2b3f5.svg";
export { ForwardRef as ReactComponent };